export default "__VITE_ASSET__BSMmQj3r__"